import { Component, ElementRef, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as moment from 'moment';
import { AppService } from '../services/app.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';

enum DisplayTypes {
  TypeOne = 1, // sameDocument true
  TypeTwo = 2, // sameDocument false
}

@Component({
  selector: 'app-add-immunization',
  templateUrl: './add-immunization.component.html',
  styleUrls: ['./add-immunization.component.scss']
})
export class AddImmunizationComponent implements OnInit {
  immunizations: any[] = []
  file: File
  selectedImmunizationTypes: any[] = []
  // expirationDate:any
  notes: string = ""
  // sameDate: boolean = true
  sameDocument: boolean = true
  immunizationDocuments: any[] = []
  currentImmunization: any
  currentDisplayType: number = DisplayTypes.TypeOne
  apiCallCount:number = 0
  btnDisabled:boolean = false
  isLoading:boolean = false

  @Output() submitted = new EventEmitter()

  @ViewChild('uploadInput') uploadInput: ElementRef

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private appService: AppService, public dialogRef:MatDialogRef<AddImmunizationComponent>) {
    this.immunizations = data.immunizations
  }

  open() {
    this.uploadInput.nativeElement.click()
  }

  openNew(immunization: any) {
    this.currentImmunization = immunization
    this.uploadInput.nativeElement.click()
  }

  ngOnInit(): void {

  }

  onChange(files: FileList) {
    if (this.sameDocument) {
      this.file = files.item(0)
      if (this.file) {
        const lowerCaseName = this.file.name.toLowerCase();
        if (!this.file.type) {
          const mimeType = this.guessMimeType(lowerCaseName);
          this.file = new File([this.file], lowerCaseName, { type: mimeType });
        } else {
          this.file = new File([this.file], lowerCaseName, { type: this.file.type });
        }
      }
    }

    if (!this.sameDocument) {
      let findedImmunization = this.immunizations.find((immunization) => immunization.petImmunizationTypeId == this.currentImmunization.petImmunizationTypeId)

      if (findedImmunization) {
        let file = files.item(0);
        if (file) {
          const lowerCaseName = file.name.toLowerCase();
          if (!file.type) {
            const mimeType = this.guessMimeType(lowerCaseName);
            file = new File([file], lowerCaseName, { type: mimeType });
          } else {
            file = new File([file], lowerCaseName, { type: file.type });
          }
  
          findedImmunization["file"] = file;
        }
      }
    }
  }
  
  guessMimeType(fileName: string) {
    const parts = fileName.split('.');
    const extension = parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
  
    const mimeTypes: { [key: string]: string } = {
      'jpg': 'image/jpeg',
      'jpeg': 'image/jpeg',
      'png': 'image/png',
      'gif': 'image/gif',
      'bmp': 'image/bmp',
      'webp': 'image/webp',
      'heic': 'image/heic',
      'pdf': 'application/pdf',
      'doc': 'application/msword',
      'txt': 'text/plain',
    };

    return extension && mimeTypes[extension] ? mimeTypes[extension] : 'application/octet-stream';
  }
  

  onCheckBoxChange() {
    if (this.sameDocument) {
      this.currentDisplayType = DisplayTypes.TypeOne
    }

    if (!this.sameDocument) {
      this.currentDisplayType = DisplayTypes.TypeTwo
    }
  }

  addImmunization() {
    if(!this.file && this.currentDisplayType == DisplayTypes.TypeOne){
      Swal.fire({
        title: 'Immunization',              
        text:'Please upload the required document',        
        icon: 'warning',
        showCancelButton: false,                                     
      })

      return
    }
    else if(this.currentDisplayType == DisplayTypes.TypeTwo){
      let findedImmunization = this.selectedImmunizationTypes.find((immunization) => !immunization.file || immunization.file == null)

      if(findedImmunization){
        Swal.fire({
          title: 'Immunization',              
          text:'Please upload the required document',        
          icon: 'warning',
          showCancelButton: false,                                     
        })
  
        return
      }
    }

    if(this.selectedImmunizationTypes.length == 0){
      Swal.fire({
        title: 'Immunization',              
        text:'Please enter the required fields',        
        icon: 'warning',
        showCancelButton: false,                                     
      })

      return
    }

    this.btnDisabled = true
    this.isLoading = true
 
    let tenant = localStorage.getItem("tenant")

    if(tenant && tenant.includes('"')){
      tenant = JSON.parse(localStorage.getItem("tenant"))
    }

    this.immunizationDocuments = []

    let list: any[] = []

    this.selectedImmunizationTypes.forEach((immunization: any) => {
      let obj = {}
      obj["petImmunizationType"] = { id: immunization.petImmunizationTypeId }

      if (this.currentDisplayType == DisplayTypes.TypeOne) {
        obj["notes"] = this.notes
      }

      if (this.currentDisplayType == DisplayTypes.TypeTwo) {
        obj["notes"] = immunization.notes
      }

      list.push(obj)
    })

    let request = { list }

    this.appService.addImmunization(this.data.petKey, request).subscribe(
      (res: any) => {
        if (res.list && res.list.length > 0) {
          res.list.forEach((obj: any) => {
            let a = {}
            a["documentId"] = obj.document.id
            a["petImmunizationTypeId"] = obj.petImmunizationType.id

            this.immunizationDocuments.push(a)
          })

          if (this.currentDisplayType == DisplayTypes.TypeOne) {
            this.selectedImmunizationTypes.forEach((immunization: any) => {
              this.uploadImmunizationCall(this.file, immunization)
            })
          }

          if (this.currentDisplayType == DisplayTypes.TypeTwo) {
            this.selectedImmunizationTypes.forEach((immunization: any) => {
              this.uploadImmunizationCall(immunization.file, immunization)
            })
          }
        }
      },

      (err) => {
        this.isLoading = false

      }
    )
  }

  uploadImmunizationCall(file: File, immunization: any) {
    this.appService.uploadImmunizationCall(file.name, file.type, this.data.petKey).subscribe(
      (res: any) => {
        this.apiCallCount++

        let uploadUrl = decodeURIComponent(res.data.url);
        let findedObj = this.immunizationDocuments.find((b) => b.petImmunizationTypeId == immunization.petImmunizationTypeId)

        if (findedObj) {
          findedObj["fileName"] = res.data.filename
          findedObj["mimeType"] = res.data.mimeType
          findedObj["physicalFilename"] = res.data.physicalFilename
        }

        this.uploadImmunizationDocument(uploadUrl, file, immunization)
      },

      (err) => {
        this.isLoading = false        

      }
    )
  }

  uploadImmunizationDocument(url: string, file:File, immunization: any) {
    this.appService.uploadImmunizationDocument(url, file, file.type).subscribe(
      (res: any) => {
        this.addAttachment(immunization)
      },

      (err) => {
        this.isLoading = false        

      }
    )
  }

  addAttachment(immunization: any) {
    let findedObj = this.immunizationDocuments.find((b) => b.petImmunizationTypeId == immunization.petImmunizationTypeId)

    if (findedObj) {
      let request = {
        list: [
          {
            name: findedObj.fileName,
            filename: findedObj.fileName,
            physicalFilename: findedObj.physicalFilename,
            mimeType: findedObj.mimeType,
            description: "",
            uploadedBy: localStorage.getItem("locationKey")
          }
        ]
      }

      this.appService.addAttachment(findedObj.documentId, request).subscribe(
        (res) => {
          immunization.status = "PENDING"
          this.submitted.emit(immunization)

          if(this.selectedImmunizationTypes.length == this.apiCallCount){
            Swal.fire({
              title: 'Success',              
              text:'Upload success',
              // confirmButtonColor: localStorage.getItem('tenantColor'),
              icon: 'success',
              showCancelButton: false,                                     
            })

            this.dialogRef.close()
          }
        },

        (err) => {
          this.isLoading = false

        }
      )
    }
  }
}
